import { render, staticRenderFns } from "./OTPInputSingle.vue?vue&type=template&id=5e5133e8&"
import script from "./OTPInputSingle.vue?vue&type=script&lang=ts&"
export * from "./OTPInputSingle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports